import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseService } from '../../../base/base.service';
import { Config } from '../../../models/Config';
import { Observable, tap } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MastersService extends BaseService {
  httpClient = inject(HttpClient);
  constructor() {
    super();
  }

  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  ownershipMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_ownership_master`, data, this.getConfig())
  }
  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/

getOwnershipMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_ownership_master`, {
    params,
    ...this.getConfig()
  });
}
  // getOwnershipMaster() {
  //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_ownership_master`, this.getConfig())
  // }
  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  fcmMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_fcm_master`, data, this.getConfig())
  }

  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  // getFcmMaster() {
  //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_fcm_master`, this.getConfig())
  // }

  getFcmMaster(page: number = 1, limit: number = 10,q:any) {
    let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
    if (q && q?.trim() !== '') {
      params = params.set('q', q.trim());
    }
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_fcm_master`, {
      params,
      ...this.getConfig()
    });
  }

  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  updateFcmMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_fcm_master`, data, this.getConfig())
  }

  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  contactDetails(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_contact_details`, data, this.getConfig())
  }

  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  // getContactDetails() {
  //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_contact_details`, this.getConfig())
  // }

  getContactDetails(page: number = 1, limit: number = 10,q:any) {
    let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
    if (q && q?.trim() !== '') {
      params = params.set('q', q.trim());
    }
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_contact_details`, {
      params,
      ...this.getConfig()
    });
  }
  /*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
  businessAreaMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_business_area_master`, data, this.getConfig())
  }

  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/

getBusinessAreaMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_business_area_master`, {
    params,
    ...this.getConfig()
  });
}

  // getBusinessAreaMaster() {
  //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_business_area_master`, this.getConfig())
  // }

  /*
   *   function name: ownershipMaster()
   *   functionality: ownership master deatails
   *   parameters : {}
   */
  vehicalReportingReg(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/vehicle_reporting_register`, data, this.getConfig())
  }

    /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
getVehicalReportingReg() {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_vehicle_reporting_register`, this.getConfig())
}

  
  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  stationMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/station_master`, data, this.getConfig())
  }

    /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
// getStationMaster() {
//   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_station_master`, this.getConfig())
// }

getStationMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<any>(`${this.getAppBaseUrl()}/get_cng_station_master`, {
    params,
    ...this.getConfig()
  });
}


  /*
   *   function name: ownershipMaster()
   *   functionality: ownership master deatails
   *   parameters : {}
   */
  energyMeterMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/energy_meter_master`, data, this.getConfig())
  }

  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  getEnergyMeterMaster() {
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_energy_meter_master`, this.getConfig())
  }

  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  dispenseMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_dispenser_master`, data, this.getConfig())
  }
  slapMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/slab-master`, data, this.getConfig())
  }
  slapMasterUpdate(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/slab-master-update`, data, this.getConfig())
  }
  getSlapMaster(page: number = 1, limit: number = 10) {
    const params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/slab-master-get`, {
      params,
      ...this.getConfig()
    });
  }
  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  // getDispenseMaster() {
  //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_dispenser_master`, this.getConfig())
  // }

  getDispenseMaster(page: number = 1, limit: number = 10,q:any) {
    let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
    if (q && q?.trim() !== '') {
      params = params.set('q', q.trim());
    }
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_dispenser_master`, {
      params,
      ...this.getConfig()
    });
  }
  /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  compressorMaster(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_compressor_master`, data, this.getConfig())
  }

  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  // getCompressorMaster() {
  //   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_compressor_master`, this.getConfig())
  // }

  getCompressorMaster(page: number = 1, limit: number = 10,q:any) {
    let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());
    if (q && q?.trim() !== '') {
      params = params.set('q', q.trim());
    }
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_compressor_master_agg`, {
      params,
      ...this.getConfig()
    });
  }
  /*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
  updateCompressorMaster() {
    return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/update_cng_compressor_master`, this.getConfig())
  }

  
    /*
*   function name: ownershipMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
GAMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_ga_master`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
getGAMasterList(page: number = 1, limit: number = 10,q='') {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString())
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_ga_drop_master`, {
    params,
    ...this.getConfig()
  });
}


getGAMaster() {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_ga_drop`, this.getConfig())
}
getGA() {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_ga_drop`, this.getConfig()).pipe(tap((result) => {
    localStorage.setItem('cng_ga', JSON.stringify(result?.data));
  }));
}

/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
cascadeMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_cascade_master`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
// getCascadeMaster() {
//   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_cascade_master`, this.getConfig())
// }

getCascadeMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }

  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_cascade_master`, {
    params,
    ...this.getConfig()
  });
}

/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
CollectionModeMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_collection_master`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
getcollectionModeMaster(page: number = 1, limit: number = 10,q='') {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<any>(`${this.getAppBaseUrl()}/get_cng_collection_master`, {
    params,
    ...this.getConfig()
  });
}


/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
VehicleMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_vehicle_master`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
// getVehicleMaster() {
//   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_vehicle_master`, this.getConfig())
// }

getVehicleMasterDropDown() {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_vehicle_master_dropdown`, this.getConfig())
}
getVehicleMasterDropDownBYGA(ga_code:any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/get_cng_vehicle_master_dropdown_based_on_ga`, {ga_code : ga_code}, this.getConfig())
}

getReportingTime(vehicle_number:any) {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_vehicle_reporting_time?vehicle_number=${vehicle_number}`, this.getConfig())
}

getVehicleMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_vehicle_master`, {
    params,
    ...this.getConfig()
  });
}

/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
EleCtrictyMeterMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/energy_meter_master`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
// getEleCtrictyMeterMaster() {
//   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_energy_meter_master`, this.getConfig())
// };

getEleCtrictyMeterMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_energy_meter_master`, {
    params,
    ...this.getConfig()
  });
}


/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
FlagMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_flag_master`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
// getFlagMaster() {
//   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_flag`, this.getConfig())
// }

getFlagMaster(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_flag_master`, {
    params,
    ...this.getConfig()
  });
}
/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
CBGMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_cbg_vendor_master`, data, this.getConfig())
}

isVendorCodeUnique(code: string) {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cbg-sap-check-unique/${code}`);
}

CustomerMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_customer_master`, data, this.getConfig())
}

deleteComDes(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_delete_dispenser_compressor`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
// getCustomerMaster() {
//   return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_customer_master`, this.getConfig())
// }

getCustomerMaster(page: number = 1, limit: number = 10,q='') {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString())
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_customer_master`, {
    params,
    ...this.getConfig()
  });
}
getVendorMaster(page: number = 1, limit: number = 10,q='') {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString())
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_get_cbg_vendor_master`, {
    params,
    ...this.getConfig()
  });
}

/*
     *   function name: ownershipMaster()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
userMaster(data: any) {
  return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_create_user`, data, this.getConfig())
}

/*
*   function name: getFcmMaster()
*   functionality: ownership master deatails
*   parameters : {}
*/
getuserMaster() {
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_user`, this.getConfig())
}


getuserMasterList(page: number = 1, limit: number = 10,q:any) {
  let params = new HttpParams()
  .set('page', page.toString())
  .set('limit', limit.toString());
  if (q && q?.trim() !== '') {
    params = params.set('q', q.trim());
  }
  return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_user_master`, {
    params,
    ...this.getConfig()
  });
  }
  
  getArmStatusDeletable(entries: any, plant_code: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_dispenser_deletable_status`, { 'entries' : entries, plant_code: plant_code }, this.getConfig())
  }
  getCompressorStatusDeletable(entries: any, plant_code: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_compressor_deletable_status`, { 'entries' : entries, plant_code: plant_code }, this.getConfig())
  }

}
